import { useState, useMemo } from 'react';
import { AMBIENTES_PADRAO } from '../../utils/especificacao';

/**
 * Ambientes do projeto onde o item vai ("Para: Banheiro social, Cozinha").
 * Toque pra marcar; os que a pessoa já usou em outros projetos vêm primeiro;
 * dá pra criar um novo (Enter).
 */
export default function SeletorAmbientes({ valor = [], onChange, sugestoes = [] }) {
  const [novo, setNovo] = useState('');
  // Ordem FIXA (sugestões, padrão e, no fim, os criados na hora): marcar um chip
  // não pode mudar a posição dos outros debaixo do dedo.
  const opcoes = useMemo(() => {
    const vistos = new Set();
    const unicos = (lista) => lista.filter(a => {
      const k = a.toLowerCase();
      if (vistos.has(k)) return false;
      vistos.add(k);
      return true;
    });
    const base = unicos([...sugestoes, ...AMBIENTES_PADRAO]).slice(0, 18);
    return [...base, ...unicos(valor)];
  }, [valor, sugestoes]);

  const marcado = (a) => valor.some(v => v.toLowerCase() === a.toLowerCase());
  const alternar = (a) => onChange(marcado(a) ? valor.filter(v => v.toLowerCase() !== a.toLowerCase()) : [...valor, a]);
  const incluir = () => {
    const a = novo.trim().replace(/\|/g, '/').slice(0, 40);
    if (a.length < 2) return;
    if (!marcado(a)) onChange([...valor, a]);
    setNovo('');
  };

  return (
    <div className="esp-amb">
      <div className="esp-amb-chips">
        {opcoes.map(a => (
          <button key={a} type="button" className={`esp-amb-chip ${marcado(a) ? 'on' : ''}`} onClick={() => alternar(a)} aria-pressed={marcado(a)}>
            {marcado(a) && <i className="bi bi-check2" />}{a}
          </button>
        ))}
      </div>
      <div className="esp-amb-novo">
        <input
          value={novo}
          placeholder="Outro ambiente (ex.: Suíte master)"
          maxLength={40}
          onChange={e => setNovo(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); incluir(); } }}
        />
        <button type="button" onClick={incluir} disabled={novo.trim().length < 2}>Adicionar</button>
      </div>
    </div>
  );
}
